import React, { useState } from 'react'
import { ApiHook } from '../../hooks/apiHook';
import { useTranslation } from 'react-i18next';
import SubscriptionReport from './SubscriptionReport';
function SubscriptionDetails() {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { t } = useTranslation()
  const report = ApiHook.CallSubscriptionReport(currentPage, itemsPerPage)
  return (
    <div>
      <div className="page_head_top">{t("subscription_report")}</div>
      <SubscriptionReport
        data={report?.data}
        type={"subscription-report"}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
       
      />
    </div>
  )
}

export default SubscriptionDetails